import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { Box, Stack, Typography } from "@mui/material";
import { blueGrey, green, red } from "@mui/material/colors";
import React from "react";

// note: to add new icon options, include it here with the appropriate condition
const iconOptions = [
  {
    condition: (summary: InternalPatientSummary) =>
      summary.isIncluded === undefined || summary.isIncluded === null,
    bg: blueGrey[50],
    icon: <PersonOutlinedIcon sx={{ color: blueGrey[600] }} />,
  },
  {
    condition: (summary: InternalPatientSummary) => summary.isIncluded,
    bg: green[50],
    icon: <ThumbUpOutlinedIcon sx={{ color: green[600] }} />,
  },
  {
    condition: (summary: InternalPatientSummary) =>
      summary.isIncluded !== undefined && !summary.isIncluded,
    bg: red[50],
    icon: <BlockOutlinedIcon sx={{ color: red[600] }} />,
  },
];

export default function PatientListItem({
  index,
  patientSummary,
}: {
  index: string | number;
  patientSummary: InternalPatientSummary;
}) {
  const year =
    patientSummary && patientSummary.procedureDate
      ? new Date(patientSummary.procedureDate).getUTCFullYear()
      : 0;

  const iconDetails = iconOptions.find((i) => i.condition(patientSummary));

  return (
    <Stack key={index} direction={"row"} className={"patient-list-item-card"}>
      <Box
        className="patient-list-icon-bubble"
        sx={{ bgcolor: iconDetails?.bg }}
      >
        {iconDetails?.icon}
      </Box>
      <Stack
        direction={"column"}
        alignItems={"flex-start"}
        className="patient-list-info"
      >
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          className="patient-list-top"
        >
          <Typography variant="body1">{`Patient ${patientSummary.patientNumber}`}</Typography>
          <Stack direction={"row"} className="categorization">
            {patientSummary.adverseEvents && <WarningAmberOutlinedIcon />}
            {patientSummary.clinicalBenefit && <MedicalServicesOutlinedIcon />}
            {patientSummary.performance && <TrendingUpOutlinedIcon />}
          </Stack>
        </Stack>
        <Typography variant="body2">Index Procedure: {year}</Typography>
      </Stack>
    </Stack>
  );
}
